<template>
	<div class="pd25">
		<div class="hd">
			<div class="title">动态验证码</div>
		</div>
		<van-field
				v-model="code"
				center
				clearable
				placeholder="6位动态验证码">
		</van-field>

		<div class="loginBtn">
			<van-button :disabled="disabledStatus" type="warning" size="large" @click="handlerLogin">登录</van-button>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { navigationTo } from '../lib/util.js';

export default {
  name: 'totp',
  data() {
    return {
      code: ''
    }
  },
  computed: {
    ...mapState('login', ['userinfo', 'redirectUrl']),
    disabledStatus() {
      return !(this.code && /^\d{6}$/g.test(this.code));
    }
	    // imgSrc() {
    //  const str = _.get(this.userinfo, 'totpImg');
    //  return `data:image/png;base64,${str}`;
	    // }
  },
  methods: {
    ...mapActions('login', ['loginByTotp']),
    handlerLogin() {
      const code = this.code;
      const { mfaTempToken } = this.userinfo;
      this.loginByTotp({ mfaTempToken, code }).then(res => {
        if (res.ssoToken) {
          return navigationTo(this.redirectUrl, res.ssoToken);
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
	.van-cell {
		padding-left: 0;
		padding-right: 0;
	}
	.van-cell:not(:last-child)::after {
		margin-left: 0;
	}
	.hd {
		padding-top: 15px;
		padding-bottom: 3px;
	}
	.imgBox, .imgTxtBox {
		text-align: center;
		font-size: 0.463768115942029rem;
	}
	.imgTxtBox {
		padding-bottom: 1rem;
	}
	.imgSelf {
		width: 125px;
	}
	.imgAppSelf {
		width: 100px;
	}
	.loginBtn {
		padding: 24px 0 16px;
	}
	.title {
		font-size: 14px;
	}
</style>
